import React, { useEffect, useState } from "react";
import useAbsoluteWindowStore from "../../stores/absoluteWindowStore";
import { useTheme } from "../../context/useThemeContext";
import styled from "styled-components";

export const MenuItemStyled = styled.div<{
    $disabled?: boolean;
    $hoverColor?: string;
}>`
    display: flex;
    background-color: transparent;
    height: 26px;
    text-align: left;
    font-size: 0.75rem;
    font-weight: 100;
    justify-content: flex-start;
    padding: 0px;
    padding-left: 8px;
    padding-right: 8px;
    color: white;
    border-radius: 2px;
    transition: background-color 0s;
    user-select: none;
    opacity: ${(props) => (props.$disabled ? ".3" : ".8")};
    cursor: ${(props) => (props.$disabled ? "default" : "pointer")};
    align-items: center;

    &:hover {
        opacity: ${(props) => (props.$disabled ? ".3" : "1")};
        background-color: ${(props) =>
            props.$disabled ? "transparent" : "rgba(255,255,255,.10)"};

        p, div {
            color: ${(props) =>
                props.$disabled
                    ? "inherit"
                    : (props.$hoverColor || "inherit") + " !important"};
        }
    }
`;

export type ContextMenuType = {
    label: string;
    secondaryText?: string | React.ReactNode;
    disabled?: boolean;
    hide?: boolean;
    icon?: React.ReactNode;
    textColor?: string;
    hoverColor?: string;
    callbackFunction?: () => void;
};

export function ContextMenuItem(props: ContextMenuType) {
    const { theme } = useTheme();

    // isDisabled is stored here to validate if callbackFunction was provided or not.
    const [isDisabled, setIsDisabled] = useState(props.disabled || false);

    // useEffect(() => {
        // if (!props.callbackFunction) {
        //     setIsDisabled(true);
        // }
    // }, [props.callbackFunction]);

    function ItemClicked(e: any) {
        if (props.disabled) {
            return;
        }

        if (props.callbackFunction) {
            props.callbackFunction();
            useAbsoluteWindowStore.getState().setWindowShowing(undefined);
        } else {
            console.log("No callback function provided");
        }
    }

    return (
        <MenuItemStyled
            $disabled={isDisabled}
            $hoverColor={props.hoverColor}
            onClick={ItemClicked}
            style={{
                display: props.hide ? "none" : "flex",
                color: theme.fontColor[50],
            }}
        >
            {props.icon && (
                <div className="mr-[10px] flex h-[15px] w-[15px] items-center justify-center">
                    {props.icon}
                </div>
            )}
            <p
                className="flex-grow-1 fit-width pr-[10px]"
                style={{
                    inlineSize: "max-content",
                    color: props.textColor || theme.fontColor[50],
                }}
            >
                {props.label}
            </p>
            <p style={{ opacity: 0.6, fontSize: "10px" }}>
                {props.secondaryText}
            </p>
        </MenuItemStyled>
    );
}

export default ContextMenuItem;
